import React, { useEffect,useState } from "react";
import AppClasses from "../../App.module.css" 

import LandingLoading from "../LandingLoading/LandingLoading";
import Landing from "../landing/Landing";
import Departments from "../Departments/Departments";
import OurWork from "../OurWork/OurWork";
import Map from "../Map/Map";
import FactsNFigures from "../FactsNFigures/FactsNFigures";
import Footer from "../Footer/Footer";
import ScrollProgress from "../UI/ScrollProgress/ScrollProgress";



import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

import { useDispatch } from "react-redux";
import { ScrollActions } from "../../store/Slices/ScrollSlice";
import HomeMobile from "./Mobile/HomeMobile";


const Home = (props) => {
  gsap.registerPlugin(ScrollTrigger);
  const dispatch = useDispatch();
  const [height, setHeight] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1000);

  const handleWidthChange = () => {
    // setWidth(window.innerWidth);
    // console.log("mobile", isMobile);
    if (window.innerWidth > 1000) {
      setIsMobile(false);
      // window.location.reload();
    } else if(window.innerWidth <= 1000){
      setIsMobile(true);
    }
  };
  const handleScroll = () => {
    if (isMobile) {
      let App = document.getElementsByClassName(AppClasses.App)[0];
      const vh = Math.max(
        document.documentElement.clientHeight || 0,
        window.innerHeight || 0
      );
      setHeight((window.pageYOffset * 100) / (App.scrollHeight - vh));
      // console.log("h,")
    }

  
  };


  useEffect(() => {

    window.addEventListener("resize", handleWidthChange); 
    window.addEventListener("scroll", handleScroll, { passive: true });

    // ScrollTrigger.refresh()
    return () => {
    //  ScrollTrigger.killAll()
      dispatch(ScrollActions.setInitial())
    };


  }, []);

  if (!isMobile) {
    
    return (
      <>
        <LandingLoading />
        <Landing />
        <Departments />
        <OurWork />
        <Map />
        <FactsNFigures />
        <Footer enableScroll={true} />
        <ScrollProgress height={props.height} />
        <div id="portal"></div>
      </>
    );
  } else {
    return (
      <HomeMobile/>
    );
  }

  // return (
  //   <>
  //     <LandingLoading />
  //     <Landing />
  //     <Departments />
  //     <OurWork />
  //     <Map />
  //     <FactsNFigures />
  //     <Footer enableScroll={true}/>
  //     <ScrollProgress height={props.height} />
  //   </>
  // );
};
export default Home;
